import {
    $axios,
    $authUser
} from '@/plugins/axios'
import {
    getUser,
    getUsers,
    getPoolCount,
    getAuthEvents,
    searchUsers,
    sendPasscode,
    listRestricteds,
    listIps
} from "@/graphql/queries";
import {
    listUserLogs
} from '@/store/custom'
import {
    updateUser,
    updateUserPassword,
    updateUserPhone,
    createSponsor,
    disableUser,
    enableUser,
    resetPassword,
    createUserLog,
    editUserGroup,
    deleteMalaUser,
    bypassMfa,
    editUserMFA,
    deleteRestricted,
    createRestricted,
    createIp,
    deleteIp,
    deleteUser
} from "@/graphql/mutations"
import {
    onCreateLog
} from "@/graphql/subscriptions"
import {
    API
} from "aws-amplify"

const state = {
    accounts: [],
    restricted: [],
    searchAccounts: [],
    account: null,
    userCount: null,
    userInfo: null,
    events: [],
    accountsLoaded: false,
    restrictedLoaded: false,
    snStatus: null,
    subscribe: "",
    allSubscribe: "",
    sponsor: false,
    restrictedModal: false,
    ips: [],
    log: {}
}

const getters = {
    // userEmails(state) {
    //     return state.accounts.map(item => item.email)
    // },
    // duplicateEmails(state, getters) {
    //     return getters.userEmails.reduce((prev, curr) => {
    //         prev[curr] = (prev[curr] || 0) + 1;
    //         return prev;
    //     }, {});
    // },
    // duplicates(state, getters) {
    //     return Object.keys(getters.duplicateEmails).filter(key => getters.duplicateEmails[key] > 1)
    // }
}

const actions = {
    async getCount({
        rootState,
        commit
    }) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: getPoolCount
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        commit("setUserCount", data.data.getPoolCount)
    },
    async secureNowStatus({
        rootState,
        commit
    }, userId) {
        const {
            data
        } = await $authUser.post(
            `/SecureNow/UserStatus`, {
                AffectedUserId: userId,
                IsMersCsr: rootState.user.mersBranded ? true : false
            }, {
                headers: {
                    Authorization: `Bearer ${
            rootState.user.user.signInUserSession.idToken.jwtToken
          }`
                }
            }
        );
        commit("setSecureNowStatus", JSON.parse(data).IsLockedOut)
    },
    async secureNowUnlock({
        rootState,
        dispatch
    }, userId) {
        try {
            await $authUser.post(
                `/SecureNow/UnlockAccount`, {
                    AffectedUserId: userId,
                    IsMersCsr: rootState.user.mersBranded ? true : false
                }, {
                    headers: {
                        Authorization: `Bearer ${
                rootState.user.user.signInUserSession.idToken.jwtToken
              }`
                    }
                }
            );
            return true
        } catch (error) {
            return false
        }
    },
    async getUserAuthEvents({
        rootState,
        commit,
        dispatch
    }, username) {
        var {
            data: {
                data: {
                    getAuthEvents: {
                        events
                    }
                }
            }
        } = await $axios.post(
            "/", {
                query: getAuthEvents,
                variables: {
                    username: username
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (!events) events = []
        let logs = await dispatch("getUserLogs", username)
        if (logs.length) {
            events.push(...logs)
        }
        commit("setEvents", events)
        dispatch("logSubscribe")
    },
    async getUserLogs({
        rootState,
        commit,
        dispatch
    }, username) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: listUserLogs,
                variables: {
                    actionOn: username,
                    sortDirection: 'DESC',
                    limit: 100
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        commit("setEvents", data.listLogs.items)
        dispatch("logSubscribe")
    },
    allLogSubscribe({
        commit
    }) {
        let sub = API.graphql({
            query: onCreateLog,
            variables: {}
        }).subscribe({
            next: logData => {
                let {
                    value: {
                        data: {
                            onCreateLog
                        }
                    }
                } = logData;
                commit("addLog", onCreateLog)
            }
        });
        commit("setAllSubscribe", sub)
    },
    logSubscribe({
        commit,
        rootState
    }) {
        let sub = API.graphql({
            query: onCreateLog,
            variables: {}
        }).subscribe({
            next: logData => {
                let {
                    value: {
                        data: {
                            onCreateLog
                        }
                    }
                } = logData;
                if (rootState.accounts.userInfo.username === onCreateLog.actionOn) {
                    commit("addEvent", onCreateLog);
                }
            }
        });
        commit("setSubscribe", sub)
    },
    logUnSubscribe({
        commit,
        state
    }) {
        state.subscribe.unsubscribe()
        commit("removeSubscribe")
    },
    allLogsUnsubscribe({
        commit,
        state
    }) {
        state.allSubscribe.unsubscribe()
        commit("removeAllSubscribe")
        commit("emptyLog")
    },
    async getUsers({
        state,
        dispatch,
        rootState,
        commit
    }, token) {
        if (state.accountsLoaded) return
        const {
            data
        } = await $axios.post(
            "/", {
                query: getUsers,
                variables: {
                    token: token
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (!data.data.getUsers) {
            console.error("Please add groups Super and Admin to Cognito")
            return
        }
        let allUsers = data.data.getUsers.Users.map(item => {
            item.error = false
            return item
        })
        commit("setUsers", allUsers)
        if (data.data.getUsers.Token) {
            dispatch("getUsers", data.data.getUsers.Token)
            return
        }
        commit("setLoaded", true)
    },
    async getRestricted({
        state,
        dispatch,
        rootState,
        commit
    }, token) {
        if (state.restrictedLoaded) return
        const {
            data
        } = await $axios.post(
            "/", {
                query: listRestricteds,
                limit: 1000,
                variables: {
                    nextToken: token
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        let res = data.data.listRestricteds
        commit("setRestrictedUsers", res.items)
        if (res.nextToken) {
            dispatch("getRestricted", res.nextToken)
            return
        }
        commit("setRestrictedLoaded", true)
    },
    async getIps({
        state,
        dispatch,
        rootState,
        commit
    }) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: listIps,
                variables: {
                    limit: 100
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        commit("setIps", data.data.listIps.items)
    },
    async removeRestricted({
        state,
        dispatch,
        rootState,
        commit
    }, a360id) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: deleteRestricted,
                variables: {
                    input: {
                        a360id
                    }
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (data.data.deleteRestricted.a360id) {
            commit("deleteRestricted", data.data.deleteRestricted.a360id)
            return true
        } else return false
    },
    async removeUser({
        rootState,
        commit
    }, user) {
        let { username, a360id, actionBy, orphaned } = user
        const {
            data
        } = await $axios.post(
            "/", {
                query: deleteUser,
                variables: {
                    username,
                    a360id,
                    actionBy,
                    orphaned
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (data.data.deleteUser) {
            commit("removeUserFromSearch", username)
            return true
        }
        else return false
    },
    async removeIp({
        rootState,
        commit
    }, address) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: deleteIp,
                variables: {
                    input: {
                        address
                    }
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
            );
        let removed = data.data.deleteIp
        if (removed.address) {
            commit("deleteIp", data.data.deleteIp.address)
            return true
        } else return false
    },
    async getUserInfo({
        rootState,
        commit
    }, username) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: getUser,
                variables: {
                    username: username
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        commit("setUser", data.getUser)
    },
    async changeUserGroup({
        rootState
    }, details) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: editUserGroup,
                variables: {
                    username: details.username,
                    addGroup: details.addGroup,
                    removeGroup: details.removeGroup
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        return data.editUserGroup
    },
    /**
     * 
     * @param {*} param0 
     * @param {*} details 
     */
    async deleteMalaUser({
        rootState
    }, details) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: deleteMalaUser,
                variables: {
                    username: details.username
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        )
        return data.deleteMalaUser
    },
    async sendCode({
        rootState
    }, details) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: sendPasscode,
                variables: {
                    number: details.number,
                    message: details.message
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        return data.sendPasscode
    },
    async disableUserAccount({
        rootState
    }, username) {
        try {
            await $axios.post(
                "/", {
                    query: disableUser,
                    variables: {
                        username: username
                    }
                }, {
                    headers: {
                        Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                    }
                }
            );
            return true
        } catch (error) {
            return false
        }
    },
    async enableUserAccount({
        rootState
    }, username) {
        try {
            await $axios.post(
                "/", {
                    query: enableUser,
                    variables: {
                        username: username
                    }
                }, {
                    headers: {
                        Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                    }
                }
            );
            return true
        } catch (error) {
            return false
        }
    },
    async createLog({
        rootState
    }, log) {
        try {
            let {
                data
            } = await $axios.post(
                "/", {
                    query: createUserLog,
                    variables: {
                        username: log.username,
                        log: log.log,
                        app: log.app
                    }
                }, {
                    headers: {
                        Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                    }
                }
            );
            return true
        } catch (error) {
            return false
        }
    },
    async searchUserAccounts({
        rootState,
        commit
    }, search) {
        try {
            let {
                data
            } = await $axios.post(
                "/", {
                    query: searchUsers,
                    variables: {
                        term: search.term,
                        ssn: search.ssn
                    }
                }, {
                    headers: {
                        Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                    }
                }
            );
            commit("setAccounts", data.data.searchUsers)
            // return true
        } catch (error) {
            // return false
        }
    },
    async resetUserPassword({
        rootState
    }, username) {
        try {
            await $axios.post(
                "/", {
                    query: resetPassword,
                    variables: {
                        username: username
                    }
                }, {
                    headers: {
                        Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                    }
                }
            );
            return true
        } catch (error) {
            return false
        }
    },
    async updateUserAtts({
        rootState
    }, newAtts) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: updateUser,
                variables: {
                    username: newAtts.userAtts.username,
                    newAtts: newAtts.userAtts.newAtts,
                    a360id: newAtts.userAtts.a360id
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (data.updateUser) return true
        else return false
        // let results = newAtts.results
        // let newData = data.data.data.updateUser
        // let keys = Object.keys(results)
        // let answers = keys.map(item => {
        //     if (results[item] === newData[item]) {
        //         return item
        //     }
        // })
        // console.log(data)
        // console.log(keys)
        // console.log(answers)
        // if (JSON.stringify(keys.sort()) === JSON.stringify(answers.sort())) {
        //     return "Saved!"
        // } else return "Error Saving Changes"
    },
    async updatePhone({
        rootState
    }, params) {
        try {
            const {
                data: {
                    data
                }
            } = await $axios.post(
                "/", {
                    query: updateUserPhone,
                    variables: {
                        username: params.username,
                        a360id: params.a360id,
                        phone: params.phone,
                        primary: params.primary,
                        prev: params.prev,
                        primaryUpdate: params.primaryUpdate,
                        currType: params.currType,
                        newType: params.newType
                    }
                }, {
                    headers: {
                        Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                    }
                }
                )
            if (data.updateUserPhone) return true
            else return false
        } catch (error) {
            console.log("updating phone error")
            return false
        }
        
    },
    async updateUserPassword({
        rootState
    }, atts) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: updateUserPassword,
                variables: {
                    username: atts.username,
                    password: atts.password
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (data.data.updateUserPassword) return true
        else return false
    },
    async snBypassMFA({
        rootState
    }, atts) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: bypassMfa,
                variables: {
                    username: atts.username,
                    bypass: atts.bypass
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (data.data.bypassMFA) return true
        else return false
    },
    async setUserMFA({
        rootState
    }, atts) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: editUserMFA,
                variables: {
                    username: atts.username,
                    mfa: atts.mfa,
                    a360id: atts.a360id
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        return data.data.editUserMFA
    },
    async newSponsor({
        rootState,
        dispatch,
        commit
    }, atts) {
        atts.newAtts.push({
            Name: "preferred_username",
            Value: atts.username
        })
        const data = await $axios.post(
            "/", {
                query: createSponsor,
                variables: {
                    username: atts.username,
                    password: atts.password,
                    newAtts: atts.newAtts
                }
            }, {
                headers: {
                    Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (data.status === 200) {
            commit("emptyAccounts")
            commit("setLoaded", false)
            // dispatch("getUsers")
            return true
        } else return data
    },
    async newRestricted({
        rootState,
        dispatch,
        commit
    }, a360id) {
        try {
            const {
                data
            } = await $axios.post(
                "/", {
                    query: createRestricted,
                    variables: {
                        input: {
                            a360id
                        }
                    }
                }, {
                    headers: {
                        Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                    }
                }
            );
            let restricted = data.data.createRestricted
            if (restricted.a360id) {
                commit("addRestricted", restricted)
                return true
            } else return false
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async newIp({
        rootState,
        dispatch,
        commit
    }, address) {
        try {
            const {
                data
            } = await $axios.post(
                "/", {
                    query: createIp,
                    variables: {
                        input: {
                            address
                        }
                    }
                }, {
                    headers: {
                        Authorization: rootState.user.user.signInUserSession.idToken.jwtToken
                    }
                }
            );
            let ip = data.data.createIp
            if (ip.address) {
                commit("addIp", ip)
                return true
            }
            else return false
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async emptyInfo({
        commit
    }) {
        commit("emptyAccount")
        commit("emptySearchAccounts")
        commit("emptyEvents")
    },
}

const mutations = {
    setUsers(state, users) {
        state.accounts = state.accounts.concat(users)
    },
    updateUserGroup(state, user) {
        state.accounts[user.ind].group = user.group
    },
    setAccounts(state, accounts) {
        state.searchAccounts = accounts
    },
    removeUserFromSearch(state, username) {
        let id = state.searchAccounts.findIndex(item => item.username === username)
        state.searchAccounts.splice(id, 1)
    },
    /**
     * Remove the item from the list with the given username
     * @param {*} state 
     * @param {*} username 
     */
    removeMalaUserFromList(state, username) {
        let index = state.accounts.findIndex(
            item => item.username === username.username
        );
        state.accounts.splice(index, 1)
    },
    emptySearchAccounts(state) {
        state.searchAccounts = []
    },
    emptyAccounts(state) {
        state.accounts = []
    },
    emptyAccount(state) {
        state.account = null
    },
    emptyEvents(state) {
        state.events = []
    },
    setUser(state, user) {
        state.userInfo = user
    },
    addRestricted(state, restricted) {
        state.restricted.push(restricted)
    },
    setError(state, acc) {
        state.accounts[acc.user].error = acc.bool
    },
    emptyUserAccount(state, user) {
        state.userInfo = null
    },
    setEvents(state, events) {
        state.events = events
    },
    addEvent(state, event) {
        state.events.push(event)
    },
    addLog(state, log) {
        state.log = log
    },
    resetUsers(state, users) {
        state.accounts = users
    },
    setUserCount(state, count) {
        state.userCount = count
    },
    setSecureNowStatus(state, status) {
        state.snStatus = status
    },
    setLoaded(state, bool) {
        state.accountsLoaded = bool
    },
    setRestrictedUsers(state, restricted) {
        state.restricted = state.restricted.concat(restricted)
    },
    setRestrictedLoaded(state, bool) {
        state.restrictedLoaded = bool
    },
    setRestricted(state, bool) {
        state.restrictedModal = bool
    },
    setSubscribe(state, sub) {
        state.subscribe = sub
    },
    setAllSubscribe(state, sub) {
        state.allSubscribe = sub
    },
    removeSubscribe(state, sub) {
        state.subscribe = ""
    },
    removeAllSubscribe(state, sub) {
        state.allSubscribe = ""
    },
    deleteRestricted(state, id) {
        let resId = state.restricted.findIndex(item => item.a360id === id)
        state.restricted.splice(resId, 1)
    },
    deleteIp(state, address) {
        let id = state.ips.findIndex(item => item.address === address)
        state.ips.splice(id, 1)
    },
    setSponsor(state, bool) {
        state.sponsor = bool
    },
    setIps(state, ips) {
        state.ips = ips
    },
    addIp(state, ip) {
        state.ips.push(ip)
    },
    emptyLog(state, log) {
        state.log = {}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}